import { handleActions } from 'redux-actions';
import {
  SHOW_TRIAL_DAYS,
  HIDE_TRIAL_DAYS,
  SET_DAYS_LEFT,
  RENEW_SESSION,
  EXPIRE_TRIAL,
} from '../actions/TrialActions';

const initialState = {
  showTrialDays: false,
  renewSession: false,
  expired: false,
};

export const TrialReducer = handleActions(
  {
    [SHOW_TRIAL_DAYS]: (state) => ({ ...state, showTrialDays: true }),
    [HIDE_TRIAL_DAYS]: (state) => ({ ...state, showTrialDays: false }),
    [SET_DAYS_LEFT]: (state, action) => ({ ...state, days_left: action.payload }),
    [RENEW_SESSION]: (state) => ({ ...state, renewSession: true }),
    [EXPIRE_TRIAL]: (state) => ({ ...state, expired: true }),
  },
  initialState,
);
